export default __webpack_public_path__ + "static/media/Poly feed 1.1940da75.jpg";